import { gql } from '@apollo/client';
import Image from 'next/image';

export default function FeaturedImage({
  image,
  width,
  height,
  className,
  priority,
  layout,
  ...props
}) {
  const src = image?.sourceUrl;
  const altText = image?.altText ?? '';

  const useFill = layout === 'fill' || (layout === undefined && !width && !height);
  const w = width ?? image?.mediaDetails?.width;
  const h = height ?? image?.mediaDetails?.height;

  if (!src) return null;

  // unoptimized: load directly from WordPress to avoid Vercel image optimization 402 when quota is exceeded
  return (
    <figure className={className}>
      {useFill ? (
        <Image
          src={src}
          alt={altText}
          fill
          sizes="100vw"
          priority={priority}
          style={{ objectFit: 'cover' }}
          unoptimized
          {...props}
        />
      ) : w && h ? (
        <Image
          src={src}
          alt={altText}
          width={w}
          height={h}
          priority={priority}
          unoptimized
          {...props}
        />
      ) : (
        <Image
          src={src}
          alt={altText}
          fill
          sizes="100vw"
          priority={priority}
          style={{ objectFit: 'cover' }}
          unoptimized
          {...props}
        />
      )}
    </figure>
  );
}

FeaturedImage.fragments = {
  entry: gql`
    fragment FeaturedImageFragment on NodeWithFeaturedImage {
      featuredImage {
        node {
          id
          sourceUrl
          altText
          mediaDetails {
            width
            height
          }
        }
      }
    }
  `,
};
